import * as Ad from "./ad";
import * as AdUnit from "./adUnit";
export { Ad, AdUnit };



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/ad/index.ts
// module id = W0rn
// module chunks = 2